<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item dataField="invoiceNumber" editorType="dxNumberBox" [label]="{ text: 'Invoice #' }"></dxi-item>
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item dataField="packingSlipNumber" editorType="dxNumberBox" [label]="{ text: 'Slip #' }"></dxi-item>
                    <dxi-item dataField="orderNumber" editorType="dxNumberBox" [label]="{ text: 'Order #' }"></dxi-item>
                    <!-- <dxi-item dataField="orderLineDetailId" [label]="{ text: 'Detail Id' }"></dxi-item> -->
                    <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                    <dxi-item dataField="paidStart" editorType="dxDateBox" [label]="{ text: 'Paid From' }"></dxi-item>
                    <dxi-item dataField="paidEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="invoiceStart" editorType="dxDateBox" [label]="{ text: 'Invoice Date From' }"></dxi-item>
                    <dxi-item dataField="invoiceEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                    <dxi-item dataField="partNumber" [label]="{ text: 'Part #' }"></dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item dataField="vin"  [label]="{ text: 'VIN' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center mt-1">
                <div *ngIf="invoices" class="me-3">{{ invoices.length }} {{ invoices.length === 1 ? 'item found' : 'items found' }}</div>
                <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="invoices">
        <dx-data-grid
            #dataGrid
            [dataSource]="invoices"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
        >
            <dxi-column dataField="invoiceNumber" caption="Invoice #" width="80" cellTemplate="printTemplate"></dxi-column>
            <dxi-column dataField="packingSlipList" caption="Slip #" width="80" cellTemplate="packSlipTemplate"></dxi-column>
            <dxi-column dataField="dealerCompany" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="quickBooksId" width="150"></dxi-column>
            <dxi-column dataField="quickBooksLastExport" caption="Exported" dataType="datetime" width="150"></dxi-column>
            <dxi-column dataField="readyToExport" caption="ReadyToExport" dataType="datetime" width="150"></dxi-column>
            <!-- <dxi-column dataField="statusDisplay" caption="Detail Status" width="150"></dxi-column> -->
            <dxi-column dataField="dealerSalesRep" caption="Sales Rep" width="150"></dxi-column>
            <dxi-column dataField="dealerEmail" caption="Email" width="200"></dxi-column>
            <dxi-column dataField="emailed" dataType="datetime" width="100"></dxi-column>
            <!-- <dxi-column dataField="deliveryMethod" width="125"></dxi-column> -->
            <dxi-column dataField="partsTotal" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="freight" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="tax" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <!-- <dxi-column dataField="fees" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column> -->
            <dxi-column dataField="total" caption="Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="invoiceDate" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="ordersList" caption="Orders" width="180" cellTemplate="ordersTemplate"></dxi-column>
            <dxi-column dataField="paid" caption="Date Paid" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="paymentTotal" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="balance" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="created" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="paymentMethods" width="100" dataType="string"></dxi-column>
            <dxi-column dataField="northpointFee" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="paymentIds" width="100"></dxi-column>
            <dxi-column dataField="" width="25"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="invoice-history-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'ordersTemplate'">
                <a *ngFor="let invoiceNumber of cell.data.ordersList" [routerLink]="[]" (click)="openInvoiceOrder(invoiceNumber)">{{ invoiceNumber || '' }} </a>
            </div>

            <div *dxTemplate="let cell of 'packSlipTemplate'">
                <a *ngFor="let packSlipNumber of cell.data.packingSlipList" [routerLink]="[]" (click)="printPackingSlip(packSlipNumber)">{{ packSlipNumber || '' }} </a>
            </div>

            <div *dxTemplate="let cell of 'printTemplate'">
                <a [routerLink]="[]" (click)="printInvoice(cell)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <!-- <button
                    class="btn btn-danger ms-2"
                    (click)="applyPayment(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Apply Payment
                </button> -->
                <button class="btn btn-secondary ms-2" (click)="queueForQBBridge()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Queue for Bridge</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="invoices" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
